import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import getConfig from '../../../../../../../../util/config';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../../constants/event-items';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    onboarding_short_url: PropTypes.string,
    has_video_album: PropTypes.bool,
    is_web_gallery: PropTypes.bool,
  }),
};

const AccountMarketingMaterialShutterbugTableTentTemplate = ({
  albumFolder,
}) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);
  const url = albumFolder.is_web_gallery
    ? `${getConfig().app.baseUrl}/galleries/view/folder/${albumFolder.id}`
    : albumFolder.onboarding_short_url;
  const includeWatermark =
    !albumFolder?.purchased_event?.features
      ?.white_label_marketing_prints_enabled &&
    !albumFolder?.purchased_event_addon_types?.includes(
      EVENT_ADDON_ITEM_TYPE.WALDOFIED,
    ) && // Covers Memory Book / GV
    !(
      albumFolder?.individual_albums &&
      albumFolder?.purchased_event_addon_types?.length > 0
    );

  return (
    <Fragment>
      <div
        style={{
          top: '6.7%',
          left: '14.15%',
          right: '62.75%',
          bottom: '75.6%',
        }}
        className="marketing-material-shutterbug-table-tent-qrcode qrcode-inverted"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.23 ?? 125}
        />
        {includeWatermark && (
          <img
            ref={templateRef}
            src={getAsset('/waldo-powered-by-inline.svg')}
            alt=""
          />
        )}
        <div className="marketing-material-event-table-tent-solicitation">
          Please send us your photos{' '}
          {albumFolder?.has_video_album && <>&amp; videos!</>}
        </div>
      </div>
      <div
        style={{
          top: '6.7%',
          left: '63.75%',
          right: '13.15%',
          bottom: '75.6%',
        }}
        className="marketing-material-shutterbug-table-tent-qrcode qrcode-inverted"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder?.has_video_album ? `${url}` : url,
            albumFolder,
          })}
          size={width * 0.23 ?? 125}
        />
        {includeWatermark && (
          <img
            ref={templateRef}
            src={getAsset('/waldo-powered-by-inline.svg')}
            alt=""
          />
        )}
        <div className="marketing-material-event-table-tent-solicitation">
          Please send us your photos{' '}
          {albumFolder?.has_video_album && <>&amp; videos!</>}
        </div>
      </div>
      <div
        style={{
          top: '74.6%',
          bottom: '7.7%',
          left: '13.15%',
          right: '63.75%',
        }}
        className="marketing-material-shutterbug-table-tent-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.23 ?? 125}
        />
        {includeWatermark && (
          <img
            ref={templateRef}
            src={getAsset('/waldo-powered-by-inline.svg')}
            alt=""
          />
        )}
        <div className="marketing-material-event-table-tent-solicitation">
          Please send us your photos{' '}
          {albumFolder?.has_video_album && <>&amp; videos!</>}
        </div>
      </div>
      <div
        style={{
          top: '74.6%',
          bottom: '7.7%',
          left: '63.25%',
          right: '13.75%',
        }}
        className="marketing-material-shutterbug-table-tent-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder?.has_video_album ? `${url}` : url,
            albumFolder,
          })}
          size={width * 0.23 ?? 125}
        />
        {includeWatermark && (
          <img
            ref={templateRef}
            src={getAsset('/waldo-powered-by-inline.svg')}
            alt=""
          />
        )}
        <div className="marketing-material-event-table-tent-solicitation">
          Please send us your photos{' '}
          {albumFolder?.has_video_album && <>&amp; videos!</>}
        </div>
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          albumFolder.has_video_album
            ? '/marketing-material/MARKETING_MATERIAL_SHUTTERBUG_TABLE_TENT_TEMPLATE_VGB.png'
            : '/marketing-material/MARKETING_MATERIAL_SHUTTERBUG_TABLE_TENT_TEMPLATE.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialShutterbugTableTentTemplate.propTypes = propTypes;

export default AccountMarketingMaterialShutterbugTableTentTemplate;
